var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyclingBmXrace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.3,39.5l10.4,10.4c1,1,2.3,1.5,3.7,1.5l23.2,0c2.8,0,5.1-2.3,5.1-5.1c0-2.8-2.3-5.1-5.1-5.1h-21L64.3,25.9 c-1.6-1.7-3.9-2.7-6.4-2.7c-2.5,0-4.7,1-6.4,2.6L25.8,51.5h25.5L63.3,39.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.1,
    cy: 19.3,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9,92.6c-12.1,0-21.9,9.8-21.9,21.9s9.8,21.9,21.9,21.9s21.9-9.8,21.9-21.9C61.7,102.4,51.9,92.6,39.9,92.6z  M39.9,133.6c-10.6,0-19.1-8.6-19.1-19.1s8.6-19.1,19.1-19.1S59,103.9,59,114.4S50.4,133.6,39.9,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6,78.4c0,12.1,9.8,21.9,21.9,21.9s21.9-9.8,21.9-21.9s-9.8-21.9-21.9-21.9C84.4,56.6,74.6,66.4,74.6,78.4z M115.6,78.4 c0,10.6-8.6,19.1-19.1,19.1S77.3,89,77.3,78.4s8.6-19.1,19.1-19.1S115.6,67.9,115.6,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,106.6c2,1.9,5.2,1.9,7.2-0.1s2-5.2,0.1-7.2l-8.9-8.9V61.6c0-2.8-2.3-5.1-5.1-5.1H24.7c0,3.2,1.3,6.1,3.4,8.2L70,106.6z  M44.8,66.8h13.3v13.3L44.8,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,108c-10.6,0-20.9,2-30.6,6.1c-9.8,4-18.5,9.9-26,17.4L59.9,144h3.8l10.6-10.6c7.2-7.2,15.7-12.9,25.1-16.8 c9.4-3.9,19.4-5.9,29.6-5.9H144V108H129z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclingBmXrace);
export default __webpack_public_path__ + "static/media/cyclingBMXrace.0d082e1b237ebf5f02575d8519f77218.svg";
export { ForwardRef as ReactComponent };